import React from "react";

import { FormControl, TextareaAutosize } from "@mui/material";
import withStyles from '@mui/styles/withStyles';
import InputLabel from "@mui/material/InputLabel";
import { styled } from "@mui/material/styles";

import { TextAreaProps } from "./types";

const TextAreaCustomized = styled(TextareaAutosize)((props) => ({
  backgroundColor: props.disabled ? "#F9FAFB" : "#FFFFFF",
  border: "1px solid #c4c4c4",
  borderRadius: "8px",
  fontFamily: "Manrope",
  fontWeight: 500,
  fontSize: "14px",
  lineHeight: "24px",
  color: "#667085",
  padding: "9px 12px",
  borderColor: "#C4C4C4",
  width: "100%",
  "&:hover": {
    borderColor: (props: { bordercolor?: string; disabled?: boolean }) =>
      !props?.disabled ? props?.bordercolor : "#C4C4C4",
  },
  "&:focus": {
    borderColor: (props: { bordercolor?: string; disabled?: boolean }) =>
      !props?.disabled ? props?.bordercolor : "#C4C4C4",
  },
  "& textarea:-webkit-autofill, textarea:-webkit-autofill:hover, textarea:-webkit-autofill:focus, textarea:-webkit-autofill:active":
    {
      "WebkitBoxShadow": "0 0 0 30px white inset !important",
      "WebkitTextFillColor": "#667085",
    },
}));

const FormControlCustomized = withStyles(() => ({
  root: {
    display: "flex",
    justifyContent: "flex-end",
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: (props: { bordercolor?: string; disabled?: boolean }) =>
        !props?.disabled ? props?.bordercolor : "#C4C4C4",
    },
    "&:active .MuiOutlinedInput-notchedOutline": {
      borderColor: (props: { bordercolor?: string; disabled?: boolean }) =>
        !props?.disabled ? props?.bordercolor : "#C4C4C4",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: (props: { bordercolor?: string; disabled?: boolean }) =>
        !props?.disabled ? props?.bordercolor : "#C4C4C4",
    },
  },
}))(FormControl);

function TextAreaForm({
  register,
  name,
  error,
  errorMessage,
  label,
  placeholder,
  className,
  ...rest
}: TextAreaProps) {
  const errorStyle: React.CSSProperties = {
    fontWeight: 500,
    fontSize: 11,
    color: "red",
  };

  const labelStyle: React.CSSProperties = {
    color: error ? "red" : "rgba(0, 0, 0, 0.54)",
  };

  return (
    <FormControlCustomized>
      {label && (
        <InputLabel style={labelStyle} id={name}>
          {label}
        </InputLabel>
      )}
      <TextAreaCustomized
        ref={register}
        name={name}
        placeholder={placeholder}
        className={className}
        {...rest}
      ></TextAreaCustomized>
      {error && <span style={errorStyle}>{errorMessage && errorMessage}</span>}
    </FormControlCustomized>
  );
}

export default TextAreaForm;
